import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BasicDetailsType, ParentDetailType, ProfileDetailsStateType } from 'src/shared/types/src';
// import { ProfileDetailsStateType } from '@parent-app/types';
// import { BasicDetailsType, ParentDetailType } from 'shared/types/src';

const initialState: ProfileDetailsStateType = {
    basicDetailsLoading: false,
    basicDetails: {} as BasicDetailsType,
    parentsDetailsLoading: false,
    parentDetails: []
}

const profileSlice = createSlice({
    name: 'profileSlice',
    initialState,
    reducers: {
        setBasicDetailsLoading: (state, action: PayloadAction<boolean>) => {
            state.basicDetailsLoading = action.payload;
        },
        setBasicDetailsData: (state, action: PayloadAction<BasicDetailsType>) => {
            state.basicDetails = action.payload;
        },
        setParentDetailsLoading: (state, action: PayloadAction<boolean>) => {
            state.parentsDetailsLoading = action.payload;
        },
        setParentData: (state, action: PayloadAction<ParentDetailType[]>) => {
            state.parentDetails = action.payload;
        },
        resetProfile: () => {
            return initialState;
        }
    }
});

export const profileAction = profileSlice.actions;
export default profileSlice.reducer;